/**
 * Normaliza alias de variables y expresiones en un diccionario para lookup rápido.
 * Devuelve:
 * {
 *   aliasToVariable: { nombreN1: {...}, emailN1: {...} },
 *   aliasToExpresion: { codigoIdentificacion: {...}, imprimePosicion_25: {...} }
 * }
 */
export function normalizaAlias(variables = [], expresiones = []) {
  const aliasToVariable = {}
  const aliasToExpresion = {}
  const pathToVariable = {}

  variables.forEach((v) => {
    if (v.alias) aliasToVariable[v.alias] = v
    if (v.fullPath) pathToVariable[v.fullPath] = v
  })

  expresiones.forEach((e) => {
    if (e.id) aliasToExpresion[e.id] = e
  })

  return { aliasToVariable, aliasToExpresion, pathToVariable }
}

export function resolverAliasRecursivo(expresion, aliasToVariable, aliasToExpresion) {
  let resultado = ''
  let i = 0

  while (i < expresion.length) {
    const start = expresion.indexOf('${', i)
    if (start === -1) {
      resultado += expresion.slice(i)
      break
    }

    resultado += expresion.slice(i, start)

    let j = start + 2
    let depth = 1
    while (j < expresion.length && depth > 0) {
      const c = expresion[j]
      if (c === '{') depth++
      else if (c === '}') depth--
      j++
    }

    if (depth !== 0) {
      resultado += expresion.slice(start, start + 2)
      i = start + 2
      continue
    }

    const tag = expresion.slice(start, j)
    const contenido = tag.replace(/^\$\{|\}$/g, '').trim()

    // Si ya es v: o i:, devolver tal cual
    if (/^(v:|i:)/.test(contenido)) {
      resultado += tag
      i = j
      continue
    }

    // Si es alias de variable
    if (aliasToVariable[contenido]) {
      const v = aliasToVariable[contenido]
      resultado += v.expresion
      i = j
      continue
    }

    // Si es alias de expresión (función guardada)
    if (aliasToExpresion[contenido]) {
      resultado += aliasToExpresion[contenido].expresion
      i = j
      continue
    }

    // No es alias → devolver intacto
    resultado += tag
    i = j
  }

  return resultado
}

/**
 * Reemplaza alias dentro del contenido de una expresión.
 * Soporta recursión: si una expresión contiene otra, también se resuelve.
 */
export function resolverAliasDentroDeExpresion(expresion, aliasToVariable, aliasToExpresion) {

  // Reemplaza placeholders internos (${alias})
  expresion = expresion.replace(/\$\{([^}]+)\}/g, (match, contenido) => {
    const limpio = contenido.trim();

    if (/^(v:|i:)/.test(limpio)) return match;

    // Alias de variable
    if (aliasToVariable[limpio]) {
      return aliasToVariable[limpio].expresion;
    }

    // Alias de función/expresión guardada
    if (aliasToExpresion[limpio]) {
      return aliasToExpresion[limpio].expresion;
    }

    return match;
  });

  // Reemplaza alias sueltos dentro de argumentos
  expresion = expresion.replace(/\b([a-zA-Z0-9_]+)\b/g, (m, palabra) => {
    if (aliasToVariable[palabra]) {
      return aliasToVariable[palabra].expresion.replace(/^\$\{|\}$/g, '');
    }
    if (aliasToExpresion[palabra]) {
      return aliasToExpresion[palabra].expresion.replace(/^\$\{|\}$/g, '');
    }
    return palabra;
  });

  return expresion;
}
